import { hideDialog } from "../../redux/guest-slices/other.slice";
import { useDispatch, useSelector } from "react-redux";
import ForumCategory from "./Create/ForumCategory";
import BlogCategory from "./Create/BlogCategory";
import { Dialog, Slide } from "@mui/material";
import Delete from "./Delete";
import Reject from "./Reject";
import Update from "./Update";
import Verify from "./Verify";

import {
  CREATE_BLOG_CATEGORY,
  CREATE_FORUM_CATEGORY,
  DELETE_BLOG,
  DELETE_BLOG_CATEGORY,
  DELETE_FAQ,
  DELETE_FORUM,
  DELETE_FORUM_CATEGORY,
  DELETE_WEBINAR,
  REJECT_SPECIALIST,
  UPDATE_BLOG_CATEGORY,
  UPDATE_FORUM_CATEGORY,
  UPDATE_WEBINAR,
  UPDATE_WEBINAR_STATUS,
  UPDTAE_BLOG_STATUS,
  UPDTAE_FORUM_STATUS,
  VERIFY_SPECIALIST,
  ASK_VERIFICATION,
  SEND_MAIL,
  DELETE_SPECIALIST,
  DELETE_MEMBER,
  UPDATE_MEMBER_STATUS,
  UPDATE_SPECIALIST_STATUS,
  DISABLE_USER_STATUS,
} from "../../utils/keywords";
import Webinar from "./Update/Webinar";
import Askverification from "./Askverification";
import SendMail from "./SendMail";
import Negative from "./Negative";

const Transition = function Transition(props) {
  return <Slide direction="down" {...props} />;
};

function DialogContainer() {
  const dispatch = useDispatch();
  const { show, type } = useSelector((state) => state.otherSlice);

  const handleClose = () => {
    dispatch(hideDialog());
  };

  return (
    <Dialog
      fullWidth
      open={show}
      maxWidth="sm"
      scroll="paper"
      translate="yes"
      id="#MuiDialog"
      onClose={handleClose}
      slots={{
        transition: Transition,
      }}
    >
      {(type === DELETE_FAQ ||
        type === DELETE_BLOG ||
        type === DELETE_FORUM ||
        type === DELETE_WEBINAR ||
        type === DELETE_BLOG_CATEGORY ||
        type === DELETE_FORUM_CATEGORY ||
        type === DELETE_SPECIALIST ||
        type === DELETE_MEMBER) && <Delete />}
      {(type === UPDTAE_BLOG_STATUS ||
        type === UPDTAE_FORUM_STATUS ||
        type === UPDATE_MEMBER_STATUS ||
        type === UPDATE_SPECIALIST_STATUS ||
        type === UPDATE_WEBINAR_STATUS) && <Update />}
      {(type === CREATE_BLOG_CATEGORY || type === UPDATE_BLOG_CATEGORY) && (
        <BlogCategory />
      )}
      {(type === CREATE_FORUM_CATEGORY || type === UPDATE_FORUM_CATEGORY) && (
        <ForumCategory />
      )}
      {type === VERIFY_SPECIALIST && <Verify />}
      {type === ASK_VERIFICATION && <Askverification />}
      {type === SEND_MAIL && <SendMail />}
      {type === REJECT_SPECIALIST && <Reject />}
      {type === UPDATE_WEBINAR && <Webinar />}

      {(
        type === DISABLE_USER_STATUS
      ) && <Negative />
      }
    </Dialog>
  );
}

export default DialogContainer;
